var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaptopSmall = function SvgLaptopSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M33.333 29.997c1.834 0 3.334-1.5 3.334-3.333V9.997c0-1.833-1.5-3.333-3.334-3.333H6.667a3.343 3.343 0 0 0-3.334 3.333v16.667c0 1.833 1.5 3.333 3.334 3.333H0v3.334h40v-3.334zm-26.666-20h26.666v16.667H6.667z"
  })));
};
export default SvgLaptopSmall;